import { apiClient } from "../../utils/apiClient";
import { User } from "../../types/users";
import { Role, UserRoles } from "../../types/userRoles";
import { LoginResponse } from "../../types/auth";



export const fetchUsers = (): Promise<User[]> => {
  return apiClient.get("/users").then((response) => response.data);
};

export const upsertUser = (user: User,
  AssignedRoles: Role[],
  RemovedRoles: Role[]
): Promise<User> => {
  return apiClient
    .post("/users/upsert", {
      UserId: user.user_id,
      AdUsername: user.ad_username,
      FullName: user.full_name,
      IsActive: user.is_active,
      CreatedBy: user.created_by,
      UpdatedBy: user.updated_by,
      AssignedRoles,
      RemovedRoles,
    })
    .then((response) => response.data);
};

export const createUser = (user: User): Promise<User> => {
  return apiClient.post("/users", user).then((response) => response.data);
};

export const updateUser = (user: User): Promise<User> => {
  return apiClient.post("/users/", user).then((response) => response.data);
};

export const deleteUser = (userId: number): Promise<void> => {
  return apiClient.delete(`/users/${userId}`).then((response) => response.data);
};

export const getUserRolesById = (userId: number): Promise<UserRoles> => {
  return apiClient
    .get(`/users/getUserRolesById/${userId}`)
    .then((response) => response.data);
};

export const getUserByName = (userName: string): Promise<User> => {
  return apiClient
    .get(`/users/username/${userName}`)
    .then((response) => response.data);
};

export const getUserAD = (userName: string): Promise<LoginResponse> => {
  return apiClient
    .get(`/users/getUserAD/${userName}`)
    .then((response) => response.data);
};

export const impersonate = (userObj: {userID: number}): Promise<LoginResponse> => {
  return apiClient.post(`/users/impersonate/`, userObj).then((response)=> response.data);
}


